import { render, staticRenderFns } from "./DraftDABulkUpdateDialog.vue?vue&type=template&id=31e5e3d5&scoped=true"
import script from "./DraftDABulkUpdateDialog.vue?vue&type=script&lang=js"
export * from "./DraftDABulkUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./DraftDABulkUpdateDialog.vue?vue&type=style&index=0&id=31e5e3d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e5e3d5",
  null
  
)

export default component.exports